// extracted by mini-css-extract-plugin
module.exports = {"accessoriesContainer":"AccessoriesTab_accessoriesContainer__CE5re","row":"AccessoriesTab_row__qRPmg"};